export const BULKLOAD_SALES_ORDERS_REQUEST = 'BULKLOAD_SALES_ORDERS_REQUEST';
export const bulkloadSalesOrders = (salesOrderIds) => ({
  type: BULKLOAD_SALES_ORDERS_REQUEST,
  salesOrderIds,
});

export const BULKLOAD_FULFILLMENT_PLANS_REQUEST = 'BULKLOAD_FULFILLMENT_PLANS_REQUEST';
export const bulkloadFulfillmentPlans = (fulfillmentPlanIds) => ({
  type: BULKLOAD_FULFILLMENT_PLANS_REQUEST,
  fulfillmentPlanIds,
});

export const BULKLOAD_SUCCESS = 'BULKLOAD_SUCCESS';
export const bulkLoadSuccess = (entities) => ({
  type: BULKLOAD_SUCCESS,
  entities,
});
